import React, { useState } from 'react'

import withQuickAdd from '../../../hooks/withQuickAdd'

import Image from '../../common/Image/Image'
import Pressable from '../../common/Pressable/Pressable'
import styles from './QuickAddHoverBtnCard.module.css'

import { withPlugin } from '@flamingo_tech/funkgo'

const QuickAddHoverBtnCard = withQuickAdd(({ onQuickAdd, selectedVariants, onClickAddCart, product, imageProps, $i18n, $detector }) => {
  const [active, setActive] = useState(false)
  const isDesktop = $detector.isDesktop()

  const injectMethods = {}
  const btnMethods = {}

  if (isDesktop) {
    injectMethods.onMouseOver = () => setActive(true)
    injectMethods.onMouseLeave = () => setActive(false)
  }

  return (
    <div {...injectMethods} className={styles.quickAddCard}>
      {
        active && (
          <Pressable
            {...btnMethods}
            className={styles.quickAddBtn}
            onClick={() => {
              onQuickAdd({
                product,
                selectedVariantInfo: selectedVariants
              })
              onClickAddCart(product)
            }}
            ariaLabel={
              product && product.title
                ? `${$i18n.transl('core.product.addToCart')}, ${product.title}`
                : $i18n.transl('core.product.addToCart')
            }
          >
            {$i18n.transl('core.product.addToCart')}
          </Pressable>
        )
      }
      <Image {...imageProps}></Image>
    </div>
  )
})

export default withPlugin(QuickAddHoverBtnCard)